import { ref } from 'vue';

const key = ref(Date.now())

export const useUpdateKey = () => {
  const refresh = () => {
    key.value = Date.now()
  }

  return { key, refresh }
}
